import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';
import { SituationKey } from '@/modules/situation/constant/SituationKey';

export class SituationType extends Enum {
  key!: SituationKey;
  value!: string;
  icon!: string;

  static COMFORTABLE_USING_TECHNOLOGY: SituationKey = {
    key: SituationKey.COMFORTABLE_USING_TECHNOLOGY,
    get value(): string {
      return Lang.t('estatesituation.comfortable-using-technology');
    },
    icon: 'screen-alternate'
  };

  static NET_VALUE_BELOW_250K: SituationKey = {
    key: SituationKey.NET_VALUE_BELOW_250K,
    get value(): string {
      return Lang.t('estatesituation.net-value-below');
    },
    icon: 'accounting-coins'
  };

  static SEPARATED_OR_DIVORCED: SituationKey = {
    key: SituationKey.SEPARATED_OR_DIVORCED,
    get value(): string {
      return Lang.t('estatesituation.separated-or-divorced');
    },
    icon: 'breakup-couple'
  };

  static BLENDED_FAMILY: SituationKey = {
    key: SituationKey.BLENDED_FAMILY,
    get value(): string {
      return Lang.t('estatesituation.blended-family');
    },
    icon: 'family-home-1'
  };

  static DISABILITIES: SituationKey = {
    key: SituationKey.DISABILITIES,
    get value(): string {
      return Lang.t('estatesituation.disabilities');
    },
    icon: 'contacts'
  };

  static ASSETS_MULTIPLE_PROVINCES: SituationKey = {
    key: SituationKey.ASSETS_MULTIPLE_PROVINCES,
    get value(): string {
      return Lang.t('estatesituation.assets-multiple-provinces');
    },
    icon: 'earth-locate'
  };

  static OWN_RECREATIONAL_PROPERTY: SituationKey = {
    key: SituationKey.OWN_RECREATIONAL_PROPERTY,
    get value(): string {
      return Lang.t('estatesituation.recreational-property');
    },
    icon: 'house'
  };

  static OWN_RENTAL_REAL_ESTATE: SituationKey = {
    key: SituationKey.OWN_RENTAL_REAL_ESTATE,
    get value(): string {
      return Lang.t('estatesituation.own-rental-estate');
    },
    icon: 'real-estate-building-house'
  };

  static INCORPORATE_OR_OWN_PRIVATE_SHARES: SituationKey = {
    key: SituationKey.INCORPORATE_OR_OWN_PRIVATE_SHARES,
    get value(): string {
      return Lang.t('estatesituation.incorporated');
    },
    icon: 'team'
  };

  static ACTIVE_FARM_OR_MINING_PROPERTY: SituationKey = {
    key: SituationKey.ACTIVE_FARM_OR_MINING_PROPERTY,
    get value(): string {
      return Lang.t('estatesituation.active-farm-or-mining-property');
    },
    icon: 'saving-piggy-dollars'
  };

  static OWN_OR_OPERATE_COMPLEX_BUSINESS_OR_CORPORATE_STRUCTURE: SituationKey = {
    key: SituationKey.OWN_OR_OPERATE_COMPLEX_BUSINESS_OR_CORPORATE_STRUCTURE,
    get value(): string {
      return Lang.t('estatesituation.operate-complex-business');
    },
    icon: 'currency-dollar-increase'
  };

  static LOVED_ONES_NOT_IN_SAME_PROVINCE: SituationKey = {
    key: SituationKey.LOVED_ONES_NOT_IN_SAME_PROVINCE,
    get value(): string {
      return Lang.t('estatesituation.not-same-province');
    },
    icon: 'astronomy-earth-rotation'
  };
}
